import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { selectCurrentMarketIndexHistoryByMonth } from '../../../../store/selectors/marketRecord'
import BaseChart from '../../Chart'
import ChartHoverSelector from './ChartHoverSelector/ChartHoverSelector'
import styles from './MarketSpotlightChart.module.scss'

const Chart = ({ className, ...restProps }) => {
  const monthlyHistory = useSelector(selectCurrentMarketIndexHistoryByMonth)
  const [index, setIndex] = useState(-1)

  useEffect(() => {
    if (monthlyHistory.length && index === -1) {
      setIndex(monthlyHistory.length - 1)
    }
  }, [index, monthlyHistory])

  return (
    monthlyHistory.length >= 3 && (
      <div className={className}>
        <div className={styles.container}>
          <BaseChart {...restProps} className={styles.chart} />
          {index > -1 && (
            <ChartHoverSelector
              index={index}
              data={monthlyHistory}
              setIndex={setIndex}
            />
          )}
        </div>
      </div>
    )
  )
}

Chart.propTypes = {
  className: PropTypes.string,
}

export default Chart
